import type { FormEvent } from "react";
import Button from "../ui/Button/Button";
import type { GuardianComposerConfig } from "./types";

type GuardianInviteComposerProps = {
  config: GuardianComposerConfig;
  targetEmail: string;
  submitting: boolean;
  error: string | null;
  onTargetEmailChange: (value: string) => void;
  onSubmit: (event: FormEvent) => Promise<void>;
};

const GuardianInviteComposer = ({
  config,
  targetEmail,
  submitting,
  error,
  onTargetEmailChange,
  onSubmit,
}: GuardianInviteComposerProps) => {
  return (
    <section className="overflow-hidden rounded-[2rem] border border-myteengig-border bg-[radial-gradient(circle_at_top_left,_rgba(191,239,255,0.6),_transparent_30%),linear-gradient(135deg,_rgba(17,119,168,1),_rgba(10,70,102,1))] p-6 text-white shadow-sm">
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white/75">{config.eyebrow}</p>
      <h2 className="mt-3 text-2xl font-semibold tracking-tight">{config.title}</h2>
      <p className="mt-3 max-w-xl text-sm leading-6 text-white/80">{config.description}</p>

      <form className="mt-6 grid gap-3 sm:grid-cols-[minmax(0,1fr)_auto]" onSubmit={(event) => void onSubmit(event)}>
        <label className="block">
          <span className="sr-only">{config.placeholder}</span>
          <input
            type="email"
            value={targetEmail}
            onChange={(event) => onTargetEmailChange(event.target.value)}
            placeholder={config.placeholder}
            className="w-full rounded-2xl border border-white/20 bg-white/95 px-4 py-3 text-sm text-myteengig-text-primary outline-none ring-0 placeholder:text-myteengig-text-muted focus:border-white"
          />
        </label>
        <Button
          type="submit"
          variant="outline"
          className="rounded-2xl border-white/30 bg-white px-5 py-3 text-myteengig-primary hover:border-white hover:bg-myteengig-secondary"
          disabled={submitting}
        >
          {submitting ? "Sending..." : config.submitLabel}
        </Button>
      </form>

      {error ? <p className="mt-4 text-sm font-medium text-red-100">{error}</p> : null}
    </section>
  );
};

export default GuardianInviteComposer;
